export class CouponUserRequest {
  assignDiscount: boolean;
  discountId: number;
  userId: number;
  organiserId?:number|undefined;


  constructor(assignDiscount: boolean, discountId: number, userId: number, organiserId: number | undefined) {
    this.assignDiscount = assignDiscount;
    this.discountId = discountId;
    this.userId = userId;
    this.organiserId = organiserId;
  }
}
